import React from "react";
import { MEDIA_URL } from "../../config/url";
// import "../../assets/css/banner.css";
// import Swiper core and required modules
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "../../assets/css/banner.css";
import { useMediaQuery, useTheme } from "@mui/material";

const Banner = ({ bannertable, fetchingDashbboard }) => {
  console.log(bannertable);
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section className="masthead -type-7">
      {!matchesSM ? (
        <Swiper
          className="main-swiper"
          spaceBetween={50}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          loop={true}
          loopFillGroupWithBlank={true}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {fetchingDashbboard ? (
            <SwiperSlide>
              {" "}
              <div className="skeleton-loader"></div>{" "}
            </SwiperSlide>
          ) : (
            bannertable.map((banner, index) => (
              <SwiperSlide key={index}>
                <div className="row justify-center text-center">
                  <div className="col-auto">
                    <div className="masthead__content">
                      <div className="masthead__bg">
                        <img
                          src={`${MEDIA_URL}${banner.Image_Path}`}
                          alt={banner.Banner_Title}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      ) : (
        <Swiper
          className="main-swiper"
          spaceBetween={50}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          loop={true}
          loopFillGroupWithBlank={true}
          modules={[Pagination, Navigation, Autoplay]}
        >
          {fetchingDashbboard ? (
            <SwiperSlide>
              {" "}
              <div className="skeleton-loader"></div>{" "}
            </SwiperSlide>
          ) : (
            bannertable.map((banner, index) => (
              <SwiperSlide key={index}>
                <div className="row justify-center text-center">
                  <div className="col-auto">
                    <div className="masthead__content">
                      <div className="masthead__bg">
                        <img
                          src={`${MEDIA_URL}${banner.Mobile_Image_Path}`}
                          alt={banner.Banner_Title}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          )}
        </Swiper>
      )}
      {/* <Carousel
        showArrows={true}
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        autoPlay={true}
        loop={true}
        interval={4000}
        transitionTime={500}
        emulateTouch={true}
      >
        {fetchingDashbboard ? (
          <div className="swiper-slide">
            {" "}
            <div className="skeleton-loader"></div>{" "}
          </div>
        ) : (
          bannertable.map((banner, index) => (
            <div key={index} className="swiper-slide">
              <div className="row justify-center text-center">
                <div className="col-auto">
                  <div className="masthead__content">
                    <div className="masthead__bg">
                      <img
                        src={`${MEDIA_URL}${banner.Image_Path}`}
                        alt={banner.Banner_Title}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </Carousel> */}
    </section>
  );
};

export default Banner;

// const Banner = ({ bannertable }) => {
//   console.log(bannertable);
//   return (
//     <>
//       <section className="masthead -type-7 animated">
//         <div className="masthead-slider js-masthead-slider-7 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
//           <div
//             className="swiper-wrapper"
//             id="swiper-wrapper-b384050792e6b1034"
//             aria-live="polite"
//             style={{
//               transitionDuration: "0ms",
//               transform: "translate3d(-1349px, 0px, 0px)",
//             }}
//           >
//             {bannertable.map((banner, index) => {
//               console.log(`${MEDIA_URL}${banner.Image_Path}`);
//               return (
//                 <div
//                   id={index}
//                   className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
//                   data-swiper-slide-index={banner.Banner_Id}
//                   role="group"
//                   aria-label="3 / 3"
//                   style={{ width: "1349px" }}
//                 >
//                   <div className="row justify-center text-center">
//                     <div className="col-auto">
//                       <div className="masthead__content">
//                         <div className="masthead__bg">
//                           <img
//                             src={`${MEDIA_URL}${banner.Image_Path}`}
//                             alt={banner.Banner_Title}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div
//             className="masthead-slider__nav -prev js-prev"
//             tabIndex="0"
//             role="button"
//             aria-label="Previous slide"
//             aria-controls="swiper-wrapper-b384050792e6b1034"
//           >
//             <button className="button -outline-white text-white size-50 rounded-full">
//               <i className="icon-arrow-left"></i>
//             </button>
//           </div>
//           <div
//             className="masthead-slider__nav -next js-next"
//             tabIndex="0"
//             role="button"
//             aria-label="Next slide"
//             aria-controls="swiper-wrapper-b384050792e6b1034"
//           >
//             <button className="button -outline-white text-white size-50 rounded-full">
//               <i className="icon-arrow-right"></i>
//             </button>
//           </div>
//           <span
//             className="swiper-notification"
//             aria-live="assertive"
//             aria-atomic="true"
//           ></span>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Banner;

{
  /* <section classNameName="masthead -type-7 animated">
        <div classNameName="masthead-slider js-masthead-slider-7 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
          <div
            classNameName="swiper-wrapper"
            id="swiper-wrapper-b384050792e6b1034"
            aria-live="polite"
            style={{
              transitionDuration: "0ms",
              transform: "translate3d(-1349px, 0px, 0px)",
            }}
          >
            {bannertable.map((rowbanner) => {
              return (
                <div
                  classNameName="swiper-slide swiper-slide-duplicate swiper-slide-prev"
                  data-swiper-slide-index={rowbanner.Banner_Id}
                  role="group"
                  aria-label="3 / 3"
                  style={{ width: "1349px" }}
                >
                  <div classNameName="row justify-center text-center">
                    <div classNameName="col-auto">
                      <div classNameName="masthead__content">
                        <div classNameName="masthead__bg">
                          <img
                            src={`${MEDIA_URL}${rowbanner.Image_Path}`}
                            alt="image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            classNameName="masthead-slider__nav -prev js-prev"
            tabIndex="0"
            role="button"
            aria-label="Previous slide"
            aria-controls="swiper-wrapper-b384050792e6b1034"
          >
            <button classNameName="button -outline-white text-white size-50 rounded-full">
              <i classNameName="icon-arrow-left"></i>
            </button>
          </div>
          <div
            classNameName="masthead-slider__nav -next js-next"
            tabIndex="0"
            role="button"
            aria-label="Next slide"
            aria-controls="swiper-wrapper-b384050792e6b1034"
          >
            <button classNameName="button -outline-white text-white size-50 rounded-full">
              <i classNameName="icon-arrow-right"></i>
            </button>
          </div>
          <span
            classNameName="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span>
        </div>
      </section> */
}
{
  /* <div
              className="swiper-slide swiper-slide-duplicate swiper-slide-prev"
              data-swiper-slide-index="2"
              role="group"
              aria-label="3 / 3"
              //   style="width: 1349px;"
              style={{ width: "1349px" }}
            >
              <div className="row justify-center text-center">
                <div className="col-auto">
                  <div className="masthead__content">
                    <div className="masthead__bg">
                      <img
                        src="https://fitizenindia.com/uploads/settings/default_slider_image_1_1693192552.jpg"
                        alt="example"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div> */
}
